import { createDrawerStore } from '../drawer/createDrawerStore';

export const useContactDrawerStore = createDrawerStore();
